<template>
  <table>
    <thead>
      <tr>
        <th>platform_transaction</th>
        <th>platform_management</th>
        <th>securities_management</th>
        <th>total</th>
        <th>total_with_deposit</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(saving, index) in total_savings" :key="index">
        <td>{{ saving.platform_transaction }}</td>
        <td>{{ saving.platform_management }}</td>
        <td>{{ saving.securities_management }}</td>
        <td>{{ saving.total }}</td>
        <td>{{ saving.total_with_deposit }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  data() {
    return {
      total_savings: this.datas.total_savings,
    };
  },
  props: {
    datas: [Object, String],
  },
};
</script>
